import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const fitbit = defineConnector({
  identifier: "fitbit",
  name: "Fitbit",
  tagLine: "Health and fitness tracking",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.fitbit\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Fitbit app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [dev.fitbit.com/apps](https://dev.fitbit.com/apps) and click **Register a new app**. Set the OAuth 2.0 Application Type to 'Server' and fill in the required details.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/fitbit/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Fitbit account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Fitbit account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://www.fitbit.com/oauth2/authorize",
    tokenEndpoint: () => "https://api.fitbit.com/oauth2/token",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.fitbit.com/1/user/-/profile.json",
  },
});
